import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import AddIcon from '@material-ui/icons/Add';
import AddRoleDialog from '../../Shared/Dialogs/AddRoleDialog';
import { roles } from '../../../Config/constants';

export default function UserRoleTable(props) {

    const classes = useStyles();
    const [addRoleDialogOpen, setAddRoleDialogOpen] = useState(false);

    const rows = props.roles.map(role => {

        if (role.id === roles.ADMINISTRATOR) {
            role.color = 'rgba(237,26,26)';
        }
        else if (role.id === roles.OPERATOR) {
            role.color = 'rgba(26,40,237)';
        }
        else if (role.id === roles.PLOEGCHEF) {
            role.color = 'rgba(27,158,62)';
        }
       
        return (createData(role.id, role.name, role.color));
    })

    function createData(id, name, color) {
        return { id, name, color};
    }

    const addRole = (roleId) => {
        props.addRole(roleId);
        setAddRoleDialogOpen(false);
    }

    const deleteRole = (id) => {
       props.deleteRole(id);
    }
    const openAddRoleDialog = () => {
        setAddRoleDialogOpen(true);
    }

    const closeDialog = () => {
        setAddRoleDialogOpen(false);
    }

    let emptyTable = props.roles.length === 0;

    return (
        <table className={classes.table}>
            <thead>
                <tr>
                    {!emptyTable && <th className={classes.headCell}></th>}
                    <th className={classes.headCell} style={{ paddingLeft: "10px" }} title={"Voeg rol toe"}>{<button className={classes.button} onClick={() => openAddRoleDialog()}><AddIcon className={classes.addButton}></AddIcon><div className={classes.addRole}>{emptyTable && "Voeg rol toe"}</div></button>}</th>
                </tr>
            </thead>
            <tbody>
                {rows.map((row) => (
                    <tr key={row.id} className={classes.row}>
                        <th className={classes.leftCell} width="90%" style={{color:row.color,fontSize:"16px"}}>{row.name}</th>
                        <th className={classes.rightCell} title={"Verwijder rol"} width="10%">{<DeleteIcon className={classes.deleteButton} onClick={() => deleteRole(row.id)}></DeleteIcon>}</th>
                    </tr>
                ))}
            </tbody>
            <AddRoleDialog dialogOpen={addRoleDialogOpen} closeDialog={closeDialog} allRoles={props.allRoles} action={addRole}></AddRoleDialog>
        </table>
    )

}

const useStyles = makeStyles(() => ({
   
    headCell: {
        fontSize: "14px",
        fontWeight: 'bold',
        color: "#020100",
        padding: "0px",
        paddingLeft: "5px",
        border: "none",
        height: "10px",
        lineHeight: "10px"
    },

    leftCell: {
        fontSize: "14px",
        color: "#020100",
        padding: "10px",
        fontWeight: "normal",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderLeft: "1px solid #DEDEDE",
        borderRadius: "6px 0 0 6px",
        backgroundColor: "white",
        paddingLeft: "20px",
    },
    midCell: {
        fontSize: "14px",
        fontWeight: "normal",
        color: "#020100",
        padding: "10px",
        paddingRight: "5px",
        paddingLeft: "5px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        backgroundColor: "white",
    },
    rightCell: {
        fontSize: "14px",
        fontWeight: "normal",
        color: "#020100",
        padding: "10px",
        borderTop: "1px solid #DEDEDE",
        borderBottom: "1px solid #DEDEDE !important",
        borderRight: "1px solid #DEDEDE",
        borderRadius: "0 6px 6px 0",
        backgroundColor: "white",
        paddingLeft: "10px",
    },
    table: {
        borderSpacing: "0 5px !important",
        borderCollapse: "separate !important",
        width: "60%",
        paddingBottom: "10px"
    },
    editButton: {
        height: "20px",
        cursor: "pointer"
    },
    deleteButton: {
        height: "20px",
        cursor: "pointer"
    },
    addButton: {
        height: "20px",
        cursor: "pointer",
        position:"relative",
        top:"5px"
    },
    arrow: {
        height: "15px",
        cursor: "pointer"
    },
    button: {
        outline: "none",
        border: "none",
        cursor: "pointer",
        backgroundColor: "rgb(1,1,1,0)"
    },
    addRole: {
        display: "inline",
    }
}));
